import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

import jsPDF from "jspdf";
import 'jspdf-autotable';
import { justifyText, justifyTextBox } from "common";

export const useFetchInitJudicialPremises = ({location, paramsURL}) => {
    
    const dispatch = useDispatch()

    const pdfLandscapeDoc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'letter',
    });
    const pdfPortraitDoc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'letter',
    });
    const pdfPortraitLegalDoc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'legal',
    });
    const pdfManager = {
        pdfLandscapeDoc,
        pdfPortraitDoc,
        pdfPortraitLegalDoc,
        justifyText,
        justifyTextBox
    }

    const { user } = useSelector((state) => state.auth)

    // console.log('user ::: ', user)

    // const { pathname } = location
    // const { COD_SOLICITUD_USUARIO } = paramsURL
    // const urlWithoutParam = pathname.split('/')[2]; // extrae solo la url (modificar-solicitud)
    // console.log('useFetchInitFormCargoServices')
    // console.log(paramsURL)
    // console.log(pathname) // TRAE ESTO: "/servicios-a-la-carga/modificar-solicitud/b9063205b678858c"
    // console.log(COD_SOLICITUD_USUARIO) // TRAE ESTO: "b9063205b678858c"
    // console.log(urlWithoutParam) // TRAE ESTO: "b9063205b678858c"

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()
    
    // Helpers ------------------------------------------------------------------------------------
    const Helpers = useHelpers()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({Helpers})    

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggleOpen = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: true,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }
    const toggleClose = () => {
        setDataModal((prev) => ({
            ...prev,
            open: false
        }))
    }
    // Para la modal -------------------------------------------------------

    // useForm ------------------------------------------------------------------------------------
    const FormScreen = useForm(defaultData.defaultFormScreen)
    const FormOtherExpense = useForm(defaultData.defaultFormOtherExpense)
    const FormFiles = useForm(defaultData.defaultFormFiles)
    const ReturnCertificateForm = useForm(defaultData.defaultReturnCertificateForm)
    const ExitPassForm = useForm(defaultData.defaultExitPassForm)
    const Forms = {
        FormScreen,
        FormOtherExpense,
        FormFiles,
        ReturnCertificateForm,
        ExitPassForm
    }
    
    // FetchData ----------------------------------------------------------------------------------
    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, pdfManager,
        //------------- globalStates
        globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms 
    }

    const fetchConsigningAuthorities = useFetchData.useFetchConsigningAuthorities({...defaultFetchParams})
    const fetchTariff = useFetchData.useFetchTariff({...defaultFetchParams})
    const fetchLocations = useFetchData.useFetchLocations({...defaultFetchParams})
    const fetchAllVehicleReception = useFetchData.useFetchAllVehicleReception({...defaultFetchParams})
    const fetchSpecificVehicleReception = useFetchData.useFetchSpecificVehicleReception({...defaultFetchParams})
    const fetchAllFiles = useFetchData.useFetchAllFiles({...defaultFetchParams})
    const fetchAllExpenseReception = useFetchData.useFetchAllExpenseReception({...defaultFetchParams})
    const fetchSpecificExpenseReception = useFetchData.useFetchSpecificExpenseReception({...defaultFetchParams})
    const fetchOtherExpenses = useFetchData.useFetchOtherExpenses({...defaultFetchParams})
    const fetchServiceTotal = useFetchData.useFetchServiceTotal({...defaultFetchParams})


    const FetchData = {
        fetchConsigningAuthorities,
        fetchTariff,
        fetchLocations,
        fetchAllVehicleReception,
        fetchSpecificVehicleReception,
        fetchAllFiles,
        fetchAllExpenseReception,
        fetchSpecificExpenseReception,
        fetchOtherExpenses,
        fetchServiceTotal,
        // fetchAllCashRegisters,
        // fetchAllBanks
    }

    // Actions ------------------------------------------------------------------------------------
    const Actions = useActions({
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, toggleOpen, toggleClose, pdfManager,
        //------------- globalStates
        globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms,
        //------------- FetchData
        FetchData
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggleOpen, toggleClose, location, paramsURL,
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    })
}